import { Body, H5, H4, Small } from "@/components/standard/BFText"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { View } from "react-native"
import Bank from "phosphor-react-native/src/icons/Bank"
import { BFLink } from "@/components/buttons/Links"
import { formatDate } from "@/utils/DateUtils"
import { displayCurrency } from "@/utils/NumberUtils"
import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { BFColors } from "@/constants/Colors"

export const LoanSummarySection = ({ loanId }: { loanId: string }) => {
  const { data: loanSummary } = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return {
        totalLoanAmount: data?.totalLoanAmount,
        interestRate: data?.interestRate,
        targetCloseDate: data?.targetCloseDate,
      }
    },
  })

  if (!loanSummary) {
    return null
  }

  return (
    <Vertical className={"gap-1.5 flex-1"}>
      <Horizontal className="justify-between">
        <H4 color={"default"}>My Loan</H4>
        <BFLink
          testId="my-loan-more-details"
          path={`/loans/${loanId}/dashboard/details`}
          text={<Small>More Details</Small>}
          size="sm"
        />
      </Horizontal>
      <View
        style={{
          backgroundColor: BFColors.lightest,
          borderColor: BFColors.lightGrey,
          borderWidth: 1,
          borderRadius: 4,
          padding: 20,
          overflow: "hidden",
        }}
      >
        <Horizontal className="justify-start flex-1 gap-3">
          <View className="p-0.5 my-auto">
            <Bank size={24} />
          </View>
          <Vertical className="flex-1">
            <Horizontal className="gap-1">
              <H5>Loan Amount:</H5>
              <H5 color="primaryLight">
                {displayCurrency({ value: loanSummary.totalLoanAmount })}
              </H5>
            </Horizontal>
            <Body className="text-dark-grey">
              This loan has an interest rate of{" "}
              {loanSummary.interestRate! * 100}% and a target closing date of{" "}
              {formatDate(loanSummary.targetCloseDate, "M/d/yyyy")}
            </Body>
          </Vertical>
        </Horizontal>
      </View>
    </Vertical>
  )
}
